var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-right"},[_c('a',{staticClass:"link-download",on:{"click":function($event){return _vm.DownloadFromUrl('/document/Niveles_catering.pdf','Niveles.pdf')}}},[_vm._v("¿Cómo se calcula tu nivel de Menú Diario?")])])
}
var staticRenderFns = []

export { render, staticRenderFns }